import React from 'react';
import styled from 'styled-components';
import { Card } from '~/components';
import devices from '~/styles/devices';

const Container = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  width: 100%;
`;
const Text = styled.p`
  margin: 0 auto;
  padding: 30px 0;
  font-size: 1.0625rem;
  text-align: center;
  color: ${({ theme }) => theme.colors.gray400};
  max-width: 400px;
`;
const Content = styled.div`
  max-width: 780px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: calc(100vh - 102px);

  @media (min-width: ${devices.tablet}) {
    flex-direction: row;
    margin: 0 auto;
  }
`;

export default function NoCards() {
  return (
    <Container>
      <Content>
        <Card noContent />
        <Text>
          Você ainda não tem nenhum cartão VR Benefícios gerado. Por favor, em
          caso de dúvidas, entre em contato com o seu RH.
        </Text>
      </Content>
    </Container>
  );
}
